import React, { useState, useRef, useEffect, useCallback } from 'react';
import './Notifications.css';
import { TreatmentModel } from '../models/superbit-api-models';
import SignalTaskServiceModel from '../models/SignalTaskServiceModel';
import { useNavigate } from 'react-router-dom';
import { ca } from 'date-fns/locale';
import { CustomerCardModel } from '../models/CustomerCardModel';
import { set } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../app-context/store';
import { setTask, setTaskStatusNotification } from '../app-context/tasksSlice';
import moment from 'moment-timezone';


export const Notifications: React.FC = () => {
    const customerCardModel: CustomerCardModel = new CustomerCardModel();

    const taskStatusNotification = useSelector((state: RootState) => state.tasks.taskStatusNotification);

    const dispatch = useDispatch();

    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [treatmentList, setTreatmentList] = useState<TreatmentModel[]>([]);
    const containerRef = useRef<HTMLDivElement>(null);

    // 1) Click‐outside closes the popup
    useEffect(() => {

        // Initialize treatmentList from localStorage if available
        initTaskList();

        const onClick = (e: MouseEvent) => {
            // if (containerRef.current && !containerRef.current.contains(e.target as Node)) {
            //     setOpen(false);
            // }
        };
        document.addEventListener('mousedown', onClick);
        return () => {
            document.removeEventListener('mousedown', onClick)
        };
    }, []);

    useEffect(() => {
        // Check if taskStatusNotification is true and open the popup
        if (taskStatusNotification) {
            initTaskList(); // Re-fetch the task list to ensure it's up-to-date
            dispatch(setTaskStatusNotification(false)); // Reset the notification state
        }
    }, [taskStatusNotification]);


    const initTaskList = async () => {
        const userLogged = localStorage.getItem('loggedUser');
        if (!userLogged) return;
        const user = JSON.parse(userLogged);


        const openAlertsNotifications = localStorage.getItem('openAlertsNotifications');
        if (!openAlertsNotifications) {
            setOpen(true); // Open the popup if treatmentList is empty
            localStorage.setItem('openAlertsNotifications', 'true');
        }

        const filter = {
            "page": 1,
            "assignmentStatus": "45cb3c16-f64f-40d5-9863-42a742ce4624",
            "treatmentById": user.id,
            "alertDateTo": moment(new Date()).tz("Israel").format('YYYY-MM-DDTHH:mm:ss').split('T')[0],
            "sortBy": [
                {
                    "property": "alertDate",
                    "SortDirection": "ASC"
                }
            ]
        }
        try {
            const assignmentsFilter = await customerCardModel.assignmentsFilter(filter);
            if (!assignmentsFilter.treatments || assignmentsFilter.treatments.length === 0) {
                console.log('No assignments found for the user:', user.id);
                await setTreatmentList([]);
                return;
            }
            console.log('Assignments fetched:', assignmentsFilter);
            const assignmentList = assignmentsFilter.treatments ? [...assignmentsFilter.treatments] : [];
            // fiter out assignments that are alertDate is small the now + 5 minutes
            const now = new Date();
            const fiveMinutesFromNow = new Date(now.getTime() + 60 * 60000); // 60 minutes in milliseconds
            const filteredAssignments = assignmentList.filter((assignment: TreatmentModel) => {
                if (!assignment.alertDate) {
                    console.log('Assignment alertDate is null', assignment);
                    return false;
                }
                const alertDate = new Date(assignment.alertDate);
                return alertDate <= fiveMinutesFromNow; // Keep assignments with alertDate within the next 5 minutes
            });
            console.log('Filtered assignments:', filteredAssignments);

            await setTreatmentList(filteredAssignments);

        } catch (error: any) {
            console.error('Error fetching tasks:', error);
        }
    }

    const checkForNotifications = useCallback(() => {
        const now = new Date();

        let treatmentsListData = [...treatmentList];
        const currentNotifications = treatmentsListData.find((item: TreatmentModel) => {
            if (!item.alertDate) {
                return false;
            }
            const alertDate = new Date(item.alertDate);
            // Check if alert date is now (within 1 minute)
            const timeDiff = Math.abs(now.getTime() - alertDate.getTime());
            return timeDiff <= 60000; // 1 minute tolerance
        });
        if (currentNotifications) {
            // set currentNotifications in first element of treatmentList
            // console.log('checkForNotifications currentNotifications', currentNotifications);
            // let updatedList = [...treatmentList];
            // // Remove the current notification from the list if it exists
            // updatedList = updatedList.filter(n => n.id !== currentNotifications.id);
            // // Add the current notification to the beginning of the list

            // updatedList.unshift(currentNotifications); // Add to the beginning of the list
            // setTreatmentList(updatedList);

            // setTreatmentList(currentNotifications);
            setOpen(true); // Auto-open notifications popup
        }
    }, [treatmentList]);

    useEffect(() => {
        const interval = setInterval(() => {
            checkForNotifications();
        }, 60000); // Check every minute

        return () => {
            clearInterval(interval);
        };
    }, [checkForNotifications]);

    // 2) websocket callback
    const updateTask = (_messageType: string, assignment: any) => {
        console.log('Websocket updateTask Notifications', _messageType, assignment);
        if (_messageType === 'NewAssignmentMessage') {
            // const newAssignment: TreatmentModel = Object.fromEntries(
            //     Object.entries(assignment).map(([k, v]) =>
            //         [k.charAt(0).toLowerCase() + k.slice(1), v]
            //     )
            // ) as any;

            // const stored = localStorage.getItem('loggedUser');
            // if (!stored) return;
            // const user = JSON.parse(stored);
            // if (newAssignment.belongsToId !== user.id) return;


            // const treatmentListData = [...treatmentList];
            // if (treatmentListData && treatmentListData.length > 0) {
            //     // Check if the assignment already exists
            //     const exists = treatmentListData.find((task: TreatmentModel) => task.id === newAssignment.id);
            //     if (!exists) {
            //         console.log('Adding new assignment to alertTasks:', newAssignment);
            //         treatmentListData.push(newAssignment);
            //         setTreatmentList(treatmentListData);
            //     }
            // }
            initTaskList(); // Re-fetch the task list to ensure it's up-to-date
        }
    };

    // 3) remove one
    const dismiss = (id: string) => {
        setTreatmentList(prev => prev.filter(n => n.id !== id));
        // Update localStorage after dismissal
    };

    const handleNavigateToTask = (taskId: string, treatmentType: any) => {
        console.log(`Navigating to task with ID: ${taskId}`);
        // Add navigation logic here
        navigate('/tasks', {
            state: {
                openEditPopup: true,
                taskId: taskId,
                treatmentType: treatmentType
            }
        });
        setOpen(false);
    };

    function getCurrentTimeHHMM(date: any): string {
        const now = new Date(date);
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        return `${hours}:${minutes}`;
    }

    return (
        <>
            <SignalTaskServiceModel onNewAssignmentMessage={updateTask} />

            <div className="notifications-container" ref={containerRef}>
                <button
                    className="bell-button"
                    onClick={() => setOpen(o => !o)}
                >
                    <div className="icon notifications"></div>
                    {treatmentList.length > 0 && <span className="badge">{treatmentList.length}</span>}
                </button>

                {open && (
                    <div className="notifications-popup">
                        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                            <div className="popup-header">הודעות אחרונות</div>
                            {treatmentList.length === 0 && (
                                <div className="empty">אין לך הודעות חדשות</div>
                            )}

                            <button
                                className="close-btn"
                                onClick={() => setOpen(false)}
                            >
                                <div className="close-icon pointer"
                                    style={{ width: '12px', height: '12px' }} >
                                </div>
                            </button>
                        </div>

                        {treatmentList.map((n: any, index: number) => (
                            <div className="notification-item" key={n.id}>
                                <div
                                    className="btn-navigation"
                                    onClick={() => handleNavigateToTask(n.id, n.treatmentType)}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <span className="dot" />
                                        <b>{n.topic}</b>
                                    </div>
                                    {n.alertDate && <p style={{ padding: 0, marginBottom: 5 }}>
                                        תאריך התזכורת: {n.alertDate.split('T')[0]} {getCurrentTimeHHMM(n.alertDate)}</p>}
                                </div>
                                {/* <button
                                    className="close-btn"
                                    onClick={() => dismiss(n.id)}
                                >
                                    <div className="close-icon pointer"
                                        style={{ width: '12px', height: '12px' }} >
                                    </div>
                                </button> */}
                            </div>
                        ))}
                    </div>
                )}

            </div>
        </>
    );
};
